import * as React from "react";

const TickIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      id="SVGRepo_iconCarrier"
      stroke="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
      d="m4.892 13.269 4.274 4.274L18.709 8"
    ></path>
  </svg>
);

export default TickIcon;
